module.exports = __webpack_public_path__ + "img/my-img.dfd1d340.png";